// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__ZQ6CF","rootSuccess":"CompleteLink_rootSuccess__DAqV0","rootFailure":"CompleteLink_rootFailure__2s_-W","isDisabled":"CompleteLink_isDisabled__2cHRy"};